/* This file is autogenerated, see readme.md for instructions */
import ScenarioSvgIcon from '@bloomreach/banana-theme/icons/scenario.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ScenarioIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ScenarioSvgIcon />
    </Icon>
  );
});

ScenarioIcon.displayName = 'ScenarioIcon';

export default ScenarioIcon;
